<div class="d-flex flex-column mb-2 gap-2">
  @for (period of periods(); track period)
  {
    <table class="table px-2 border mb-0">
      <thead>
        <tr>
          <th colspan="3"><strong>{{period.displayName}}</strong></th>
        </tr>
      </thead>
      <tbody>
        @if (!period.taskTypeGroups?.length && period.period < lastPeriod())
        {
          <tr>
            <td colspan="3" class="text-center">
              <div class="alert alert-primary mb-0">All minutes reserved.</div>
            </td>
          </tr>
        }
        @for (group of period.taskTypeGroups; track group)
        {
          <tr [class.bg-light]="openedTaskGroups.has(group)">
            <td class="w-75">
              @if (group.isManual)
              {
                <span [ngbPopover]="group.taskTypeDescription" popoverTitle="Description" placement="left auto" triggers="mouseenter:mouseleave"
                  (click)="toggleOpenCustomTaskGroup(group)" class="cursor-pointer">
                  {{group.taskTypeName}}
                </span>
                <a (click)="toggleOpenCustomTaskGroup(group)" class="cursor-pointer ms-1">
                  <i [ngClass]="openedTaskGroups.has(group) ? 'fa-caret-up' : 'fa-caret-down'" class="fas"></i>
                </a>
              }
              @else
              {
                <span [ngbPopover]="group.taskTypeDescription" popoverTitle="Description" placement="left auto" triggers="mouseenter:mouseleave">
                  {{group.taskTypeName}}
                </span>
              }
            </td>

            <td>
              <span class="float-end">
                {{group.workItems.length}}
              </span>
            </td>
          </tr>
          @if (group.isManual && openedTaskGroups.has(group))
          {
            <tr>
              <td colspan="4" class="ps-4">
                <div class="d-flex flex-column gap-2">
                  @for(item of group.workItems; track item)
                  {
                    <div>
                      {{ item.WorkDisplayName }} <span *ngIf="item.WorkRequestWebsiteUrl">- {{ item.WorkRequestWebsiteUrl}}</span>
                    </div>
                  }
                </div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  }
</div>